const breadCrumb =
  "Lotação de Servidores - Consultas de Informações do Servidor";

const routes = [
  {
    path: "/consulta-de-lotacao-por-local",
    name: "consulta-de-lotacao-por-local",
    meta: {
      allowedPermissions: ["lotacao_por_local_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaDeLotacaoPorLocal/ConsultaDeLotacaoPorLocalHome.vue"
      ),
  },
  {
    path: "/consulta-de-lotacao-por-local/:id/visualizar",
    name: "consulta-de-lotacao-por-local-visualizar",
    meta: {
      allowedPermissions: [
        "lotacao_por_local_show_habilitacao",
        "lotacao_por_local_list_movimentacoes",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaDeLotacaoPorLocal/ConsultaDeLotacaoPorLocalVisualizar.vue"
      ),
  },
];

export default routes;
